import dynamic from "next/dynamic";

const Banner = dynamic(
	() => import("components/banner/banner"),
);

const Mobile = (props) => {

	const prop = props;
	return (

		<>
			<div className="ads-container">
				<Banner
					component_id="staticbanner2"
					name="staticbanner2"
					placeholder="staticbanner2"
					is_mobile={prop.isMobile}
					class_name="mobile-staticbanner2"
				/>
				<style jsx>
					{`
                    .ads-container {
                        display: flex;
                        align-content: center;
                        justify-content: center;
                    }
                `}
				</style>
			</div>
			<div className="container-fake-free">
				<div className="child-container-fake-free">
					<div className="description-section">
						<div className="title-section">
							<p className="title-fake-free">Keep your beauty review</p>
							<img className="stamp-fake-free" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/stamp-fake-free.png" alt="illustration" />
						</div>
						<p className="description-fake-free">with authentic & honest reviews from your personal experience</p>
						<a href={`${process.env.NEXT_PUBLIC_ROOT_HOME}/terms-and-conditions`} className="term-and-condition">
							READ TERMS & CONDITION
							<img className="ic-next" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/ic-next.svg" alt="illustration" />

						</a>
					</div>
					<img className="ic-illustration" src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/illustration-fake-free-mobile.svg" alt="illustration" />

				</div>

				<style jsx>
					{`
                    .container-fake-free{
                        background-image: url("https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/background-fake-free.svg");
                        background-repeat: no-repeat;
                        background-size: cover;
                        padding: 12px 16px 0 16px;
                        max-width: 450px;
                        margin: 32px auto 32px auto;
                    }
                    .child-container-fake-free{
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        align-items: center;
                        justify-content: center;
                    }
                    .title-section{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .title-fake-free{
                        font-family: 'Merriweather';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 18px;
                        line-height: 23px;
                        color: #DC274F;
                        margin:0;
                    }
                    .stamp-fake-free{
                        width: 84px;
                    }
                    .description-section{
                        margin-bottom: 11px;
                    }
                    .description-fake-free{
                        font-family: 'Roboto';
                        font-style: normal;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 20px;
                        text-align: center;
                        color: #323942;
                        margin-top: 2px;
                        margin-bottom: 8px;
                    }
                    .term-and-condition{
                        font-family: 'Poppins';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 10px;
                        line-height: 20px;
                        text-align: right;
                        letter-spacing: 0.1em;
                        text-transform: capitalize;
                        color: #000000;
                        padding-bottom: 4px;
                        border-bottom: 1px solid black;
                        width: 182px;
                        margin: auto;  
                        display: flex; 
                        align-items: center;
                        justify-content: center;
                    }
                    .ic-next{
                        margin-left: 13px;
                    }
				`}
				</style>
			</div>
		</>
	);

};

export default Mobile;
